import * as z from "zod";
import { requiredString } from "components/form/utils";

export const kekaSchema = z.object({
    client_id: requiredString(),
    client_secret: requiredString(),
    api_key: requiredString(),
    base_url: requiredString(),
});
